export function useGoogleAnalytics() {
    function onGtag(
        action = 'form_field_focused',
        value = null
    ) {
        gtag('event', action, {
            ...value,
            debug_mode: true
        });
    }

    function trackPageView(path = window.location.pathname, title = document.title) {
        onGtag('page_view', {
            page_path: path,
            page_title: title,
        });
    }

    function trackFormFieldFocus(fieldName) {
        onGtag('form_field_focused', {
            field_name: fieldName,
        });
    }

    function trackFormSubmission(formName) {
        onGtag('form_submitted', {
            form_name: formName,
        });
    }

    function trackButtonClick(buttonName) {
        onGtag('button_click', {
            button_name: buttonName,
        });
    }

    function trackCustomEvent(eventName, params = {}) {
        onGtag(eventName, params);
    }


    return {
        onGtag,
        trackPageView,
        trackFormFieldFocus,
        trackFormSubmission,
        trackButtonClick,
        trackCustomEvent,
    };
}